import { useState } from "react";
import styled from "styled-components";

const GalleryContainer = styled.div`
  padding: 40px 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  background: linear-gradient(135deg, #1a1a1a 0%, #2d2d2d 100%);
  min-height: 100vh;
`;

const MainImageContainer = styled.div`
  width: 70%;
  max-width: 800px;
  aspect-ratio: 16/9;
  margin-bottom: 30px;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 
    0 20px 40px rgba(0, 0, 0, 0.4),
    0 0 0 1px rgba(255, 255, 255, 0.1),
    inset 0 1px 0 rgba(255, 255, 255, 0.1);
  position: relative;
  background: #000;
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(45deg, transparent 30%, rgba(255, 255, 255, 0.02) 50%, transparent 70%);
    pointer-events: none;
    z-index: 1;
  }
`;

const MainImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: contain;
  filter: contrast(1.1) saturate(1.1);
  transition: all 0.3s ease;
  
  &:hover {
    transform: scale(1.02);
  }
`;

const ThumbnailGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(100px, 1fr));
  gap: 15px;
  width: 100%;
  max-width: 900px;
  padding: 20px;
  background: rgba(0, 0, 0, 0.3);
  border-radius: 16px;
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.1);
`;

const ThumbnailContainer = styled.div`
  position: relative;
  border: ${(props) =>
    props.isSelected ? "3px solid #ffd700" : "2px solid rgba(255, 255, 255, 0.2)"};
  border-radius: 12px;
  overflow: hidden;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  background: #000;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
  
  &:hover {
    border-color: #ffd700;
    transform: translateY(-4px) scale(1.05);
    box-shadow: 0 8px 25px rgba(255, 215, 0, 0.3);
  }
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(135deg, transparent 0%, rgba(255, 255, 255, 0.1) 100%);
    opacity: 0;
    transition: opacity 0.3s ease;
    z-index: 1;
  }
  
  &:hover::before {
    opacity: 1;
  }
`;

const Thumbnail = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  filter: brightness(0.9) contrast(1.1);
  transition: all 0.3s ease;
  
  ${ThumbnailContainer}:hover & {
    filter: brightness(1.1) contrast(1.2);
    transform: scale(1.1);
  }
`;

const Gallery = () => {

    const images = [
        {
          id: 1,
          url: "https://ik.imagekit.io/dnddecpho/airvitamin/IMG-20170625-WA0006_hfjFaGnEj.jpg?updatedAt=1733064640041"
        },
        {
          id: 2,
          url: "https://ik.imagekit.io/dnddecpho/airvitamin/IMG-20170226-WA0003_7dfIEUg3y.jpg?updatedAt=1733064637998"
        },
        {
          id: 3,
          url: "https://ik.imagekit.io/dnddecpho/airvitamin/IMG-20170606-WA0030_eSnjCL2rt.jpg?updatedAt=1733064637947"
        },
        {
          id: 4,
          url: "https://ik.imagekit.io/dnddecpho/airvitamin/IMG-20170528-WA0002_EN5IWvYhT.jpg?updatedAt=1733064637899"
        },
        {
          id: 5,
          url: "https://ik.imagekit.io/dnddecpho/airvitamin/IMG-20170528-WA0012_EyGPhG06OQ.jpg?updatedAt=1733064637543"
        },
        {
          id: 6,
          url: "https://ik.imagekit.io/dnddecpho/airvitamin/IMG-20161218-WA0026_gKNVchNwz.jpg?updatedAt=1733064637500"
        },
        {
          id: 7,
          url: "https://ik.imagekit.io/dnddecpho/airvitamin/IMG-20161218-WA0017_Ie_HIrsNsu.jpg?updatedAt=1733064637295"
        },
        {
          id: 8,
          url: "https://ik.imagekit.io/dnddecpho/airvitamin/IMG-20170226-WA0000_SffGIe1gl.jpg?updatedAt=1733064637230"
        },
        {
          id: 9,
          url: "https://ik.imagekit.io/dnddecpho/airvitamin/IMG-20160927-WA0014_tT-RyORDE.jpg?updatedAt=1733064637185"
        },
        {
          id: 10,
          url: "https://ik.imagekit.io/dnddecpho/airvitamin/IMG-20160927-WA0012_6M1rCwMc0.jpg?updatedAt=1733064637194"
        },
        {
          id: 11,
          url: "https://ik.imagekit.io/dnddecpho/airvitamin/IMG-20160927-WA0008_JW9-RyXBP.jpg?updatedAt=1733064637099"
        },
        {
          id: 12,
          url: "https://ik.imagekit.io/dnddecpho/airvitamin/IMG-20160927-WA0007_SAeh9aGOA3.jpg?updatedAt=1733064634503"
        },
        {
          id: 13,
          url: "https://ik.imagekit.io/dnddecpho/airvitamin/IMG-20160401-WA0001_Xaab9TXxa.jpg?updatedAt=1733064634571"
        },
        {
          id: 14,
          url: "https://ik.imagekit.io/dnddecpho/airvitamin/IMG-20160827-WA0003_C6JZODNRgD.jpg?updatedAt=1733064634526"
        },
        {
          id: 15,
          url: "https://ik.imagekit.io/dnddecpho/airvitamin/IMG-20160827-WA0023_omFiS45Zvt.jpg?updatedAt=1733064634474"
        },
        {
          id: 16,
          url: "https://ik.imagekit.io/dnddecpho/airvitamin/IMG-20160802-WA0005_TF8aIKxtA.jpg?updatedAt=1733064634466"
        },
        {
          id: 17,
          url: "https://ik.imagekit.io/dnddecpho/airvitamin/IMG-20160927-WA0003_FZIB4KU4kV.jpg?updatedAt=1733064634463"
        },
        {
          id: 18,
          url: "https://ik.imagekit.io/dnddecpho/airvitamin/IMG-20160330-WA0005_nFoTFgIjZ2.jpg?updatedAt=1733064634434"
        },
        {
          id: 19,
          url: "https://ik.imagekit.io/dnddecpho/airvitamin/IMG-20160330-WA0011_otYafLiau.jpg?updatedAt=1733064634429"
        },
        {
          id: 20,
          url: "https://ik.imagekit.io/dnddecpho/airvitamin/IMG-20160802-WA0015_aQfwu0tUf.jpg?updatedAt=1733064634331"
        },
        {
          id: 21,
          url: "https://ik.imagekit.io/dnddecpho/airvitamin/IMG-20160330-WA0004_iwlk1Hra7.jpg?updatedAt=1733064634197"
        },
        {
            id: 22,
            url: "https://ik.imagekit.io/dnddecpho/airvitamin/DSC04008_C9gp3TP1n.png?updatedAt=1733066388935"
        },
        {
            id: 23,
            url: "https://ik.imagekit.io/dnddecpho/airvitamin/IMG_20170610_164319_LSlwEWr25.png?updatedAt=1733066388770"
        },
        {
            id: 24,
            url: "https://ik.imagekit.io/dnddecpho/airvitamin/IMG_20170609_212336_ALboY-wqL.png?updatedAt=1733066388710"
        },
        {
            id: 25,
            url: "https://ik.imagekit.io/dnddecpho/airvitamin/IMG_20170722_162312_JhlAKMHS9.png?updatedAt=1733066388649"
        },
        {
            id: 26,
            url: "https://ik.imagekit.io/dnddecpho/airvitamin/IMG_20170805_175409_TSYJmst7-.png?updatedAt=1733066502770"
        }
      ];
      

  const [mainImage, setMainImage] = useState(images[0].url);

  const handleThumbnailClick = (url) => {
    setMainImage(url);
  };

  return (
    <GalleryContainer>
      <MainImageContainer>
        <MainImage 
          src={mainImage} 
          alt="Main Display" 
          key={mainImage}
          style={{
            animation: 'fadeIn 0.5s ease-in-out'
          }}
        />
      </MainImageContainer>
      <ThumbnailGrid>
        {images.map((image, index) => (
          <ThumbnailContainer
            key={image.id}
            isSelected={mainImage === image.url}
            onClick={() => handleThumbnailClick(image.url)}
            style={{
              animation: `slideInUp 0.6s ease-out ${index * 0.1}s both`
            }}
          >
            <Thumbnail src={image.url} alt={`Thumbnail ${image.id}`} />
          </ThumbnailContainer>
        ))}
      </ThumbnailGrid>
      
      <style jsx>{`
        @keyframes fadeIn {
          from {
            opacity: 0;
            transform: scale(0.95);
          }
          to {
            opacity: 1;
            transform: scale(1);
          }
        }
        
        @keyframes slideInUp {
          from {
            opacity: 0;
            transform: translateY(30px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
      `}</style>
    </GalleryContainer>
  );
};

export default Gallery;
